module.exports = __webpack_public_path__ + "static/media/dying_sound.9df99418.mp3";